// extracted by mini-css-extract-plugin
export default {"reach-create-campaign":"CreateCampaign_reach-create-campaign__ZJ2l+","reach-create-campaign__body":"CreateCampaign_reach-create-campaign__body__KhftQ"};